/**
 * GeChiUI dependencies
 */
import { unwrap } from '@gechiui/dom';

export default function googleDocsUIdRemover( node ) {
	if ( ! node.id || node.id.indexOf( 'docs-internal-guid-' ) !== 0 ) {
		return;
	}

	unwrap( node );
}
